<div class="container">
  <div style="margin-top: 32px;">
    <h1 fxShow.gt-xs="true" fxShow="false">Welcome {{currentUser.fullName}}</h1>
    <h6 fxShow.xs="true" fxShow="false">Welcome {{currentUser.fullName}}</h6>
    <p>Please wait while we load your applications...</p>
    <div style="margin-top:18px;">
      <mat-spinner [diameter]='24'></mat-spinner>
    </div>
  </div>
</div>